module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-Light.f5ea9ff5.ttf";